import { FC } from 'react';

import { LeftArrow, NavigatorButtons, RightArrow } from './tableNavigator.sc';

interface Props {
  scrollOn: (direction: 'forward' | 'back') => void;
}

const TableNavigator: FC<Props> = ({ scrollOn }) => {
  const stepForward = () => scrollOn('forward');
  const stepBack = () => scrollOn('back');
  return (
    <NavigatorButtons>
      <div onClick={stepBack}>
        <LeftArrow width={15} name="iconDropDownArrow" />
      </div>
      <div onClick={stepForward}>
        <RightArrow width={15} name="iconDropDownArrow" />
      </div>
    </NavigatorButtons>
  );
};

export default TableNavigator;
